export default "__VITE_ASSET__4fad36e0__"